import ElementContentThankyou from '@/components/sections/builder/elements/body/thankyou/content';
import ElementSettingThankyou from '@/components/sections/builder/elements/body/thankyou/setting';
import { ThankYouElementDataType } from '@/components/sections/builder/elements/body/thankyou/type';
import { HandHeart } from 'lucide-react';

const defaultData: ThankYouElementDataType = {
  name: 'Thank You',
  labelThankyou: 'Thank You For Shopping With Us',
  labelButton: 'Back to Homepage',
  imageUrl: '',
  showHomeButton: false,
};

export const ElementPreviewIcon = HandHeart;

const ThankYou = {
  type: 'thankyou',
  group: 'body_thankyou',
  defaultData,
  Element: ElementContentThankyou,
  Setting: ElementSettingThankyou,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  maxEntries: 1,
  isImmutable: true,
};

export default ThankYou;
